import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { USER_AGENT } from '../../../express.tokens';

@Injectable()
export class UniversalDeviceDetectorService extends DeviceDetectorService {
    constructor(
        @Inject(PLATFORM_ID) platformId: any,
        @Optional() @Inject(USER_AGENT) userAgent: string
    ) {
        super(platformId);
        if (isPlatformServer(platformId) && userAgent) {
            super.setDeviceInfo(userAgent);
        }
    }
}
